import React from 'react';

const ImageBoxFour = ({imageOne, imageTwo})=> (
  <div className="img-box4">
    <div className="img-1" style={{margin:0}}><img style={{width:521,height:460,objectFit:'cover'}} src={imageOne} alt="about"/></div>
    <div className="img-2" ><img style={{width:417,height:280,objectFit:'cover',border:'10px solid #ffffff'}}src={imageTwo} alt="about"/></div>
  </div>
);

export default ImageBoxFour;